import React from 'react';
import Link from "next/link";

const Footer = ({t}) => {

    const footer = t('common:footer', {}, {returnObjects: true});

    const BottomItem = ({item}) => {
        return <li className='list_item'>
            <Link
                className='list_item_link'
                prefetch={false}
                href={item.url}
                target={item.target}
            >
                {item.title}
            </Link>
        </li>
    }

    return (
        <footer className='footer'>
            <div className="container">
                <ul className="footer_links">
                    {footer.bottom.map(el => {
                        return <BottomItem
                            key={el.title}
                            item={el}
                        />
                    })}
                </ul>
                <p className='footer_copyright'>
                    © PEPE Dollar {new Date().getFullYear()}. {footer.copy}
                </p>
            </div>
        </footer>
    );
}

export default Footer;